"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = void 0;
const tslib_1 = require("tslib");
const pino_1 = tslib_1.__importDefault(require("pino"));
// https://getpino.io/#/docs/help?id=mapping-pino-log-levels-to-google-cloud-logging-stackdriver-serverity-levels
const PinoLevelToSeverityLookup = {
    debug: 'debug',
    info: 'info',
    warn: 'warning',
    error: 'error',
    fatal: 'critical',
};
function getSeverity(level) {
    var _a;
    return ((_a = PinoLevelToSeverityLookup[level]) !== null && _a !== void 0 ? _a : PinoLevelToSeverityLookup['info']);
}
const defaultPinoConf = {
    messageKey: 'message',
    formatters: {
        level(label, number) {
            const severity = getSeverity(label);
            return {
                severity,
                level: number,
            };
        },
        log(args) {
            return args;
        },
    },
};
function createLogger(options) {
    var _a, _b;
    if (((_b = (_a = global === null || global === void 0 ? void 0 : global.process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV) === 'development') {
        defaultPinoConf.transport = {
            target: 'pino-pretty',
            options: {
                messageKey: 'message',
                translateTime: 'yyyy-mm-dd hh:MM:ss Z',
                ignore: 'pid,hostname,name,severity',
            },
        };
    }
    return (0, pino_1.default)(Object.assign(Object.assign({}, options), defaultPinoConf));
}
exports.createLogger = createLogger;
//# sourceMappingURL=log.js.map